// document.querySelectorAll('.mega-menu__item-link').forEach((link) => {
//   link.addEventListener('mouseenter', function () {
//     const childData = this.getAttribute('child-data');

//     // Remove active class from all menu links
//     document.querySelectorAll('.mega-menu__item-link').forEach((item) => {
//       item.classList.remove('list-menu__item--active');
//     });

//     // Add active class to current link
//     this.classList.add('list-menu__item--active');

//     // Remove active from all mega menu contents
//     document.querySelectorAll('.child-mega-menu-wrap').forEach((item) => {
//       item.classList.remove('active');
//     });

//     // Add active to matching content
//     const target = document.querySelector(`.child-mega-menu-wrap.${childData}`);

//     if (target) {
//       target.classList.add('active');
//     }
//   });
// });
document.querySelectorAll('.mega-menu__item-link').forEach((link) => {
  link.addEventListener('mouseenter', function () {
    const childData = this.getAttribute('child-data');

    // Active menu item
    document.querySelectorAll('.mega-menu__item-link').forEach((item) => {
      item.classList.remove('list-menu__item--active');
    });

    this.classList.add('list-menu__item--active');

    // Hide all submenu wrappers
    document.querySelectorAll('.child-mega-menu-wrap').forEach((item) => {
      item.classList.remove('active');
    });

    // Show matching submenu wrapper
    const targetSubmenu = document.querySelector(
      `.child-mega-menu-wrap.${childData}`
    );

    if (targetSubmenu) {
      targetSubmenu.classList.add('active');
    }

    // Show matching promo wrap (leave current active promo-wrap alone if none matches)
    const targetPromo = document.querySelector(
      `.promo-wrap.submenu-wrapper--${childData}`
    );

    if (targetPromo) {
      document.querySelectorAll('.promo-wrap').forEach((item) => {
        item.classList.remove('active');
      });

      targetPromo.classList.add('active');
    }
  });
});